<!-- Input Text Template -->
<ng-template #input_text_template>
  <input id="{{ name }}"
    [attr.aria-labelledby]="name + '_label'"
    type="{{ inputType }}"
    class="{{ inputClass }}"
    [disableControl]="disabled"
    [placeholder]="placeholder | translate"
    [ngModel]="model"
    [ngModelOptions]="{standalone: true}"
    (change)="valueChange.emit($event)"
    pInputText />
</ng-template>
<!-- Text Input -->
<div class="w-full"
     [class.field]="formField">
  @if (label) {
    <label
      id="{{ name }}_label"
      class="flex flex-grow-1"
      [class.mb-2]="!formField"
      for="{{ name }}">
      <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
        {{ label | translate }}
      </span>
    </label>
  }
  @if (!inputGroup) {
    <ng-container *ngTemplateOutlet="input_text_template"></ng-container>
  } @else {
    <div medsurf-design-content-input-group>
      <ng-container *ngTemplateOutlet="input_text_template"></ng-container>
      <ng-content></ng-content>
    </div>
  }
</div>